import "./index.scss";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../component/authProvider";
import ClientLayout from "../../component/appLayouts/clientLayout/clientLayout";
import { useForm } from "react-hook-form";
import InfiniteScroll from "react-infinite-scroll-component";

import AppButton from "../../component/AppButton";
import SelectForm from "../../component/selectForm";
import { showSuccessToaster } from "../../component/toasters/success";
import { showErrorToaster } from "../../component/toasters/error";
import ModalForm from "../../component/modal";
import DevisService from "../../services/devis.service";
import Loading from "../../component/loading";
import DevisUser from "../../component/devisUser";

import emptyDevis from "../../assets/emtyDevis.png";
import iconSearch from "../../assets/Search.png";
import { List } from "react-bootstrap-icons";
import ListIcon from "../../component/icons/listIcon";
import GridIcon from "../../component/icons/gridIcon";


function ClientsDevisList() {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const userId = currentUser?.userId;
  const firstname = currentUser?.firstname?.split(" ")[0];
  const [viewMode, setViewMode] = useState("grid"); // "grid" ou "list"
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const [hasMore, setHasMore] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [devisList, setDevisList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const currentUserId = currentUser?.userId;
  const [devisLists, setDevisLists] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");

  const {
    setValue,
    handleSubmit,
    watch,
    register: formRegister,
    formState: { errors },
  } = useForm({
    defaultValues: {
      userId: userId,
      activitySector: "",
      servicesDemandes: [],
      budgetEstime: "",
      devise: "",
      description: "",
      dateSoumission: "",
      pieceJointe: null,
    },
  });

  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await DevisService.getAllClientsDevis();

      let clientDevis = [];

      if (Array.isArray(res)) {
        if (currentUser?.role === "client") {
          clientDevis = res.filter(
            (devis) => devis.clientId?._id?.toString() === currentUser?.userId?.toString()
          );

        } else {
          clientDevis = res;
        }

        setDevisList(clientDevis);
        setFilteredData(clientDevis);
      } else {
        setDevisList([]);
        setFilteredData([]);
      }
    } catch (error) {
      showErrorToaster("Une erreur est survenue.");
    }
    setIsLoading(false);
  };

  const fetchMoreData = async () => {
    if (filteredData.length >= devisList.length) {
      setHasMore(false);
      return;
    }

    try {
      const res = await DevisService.getAllClientsDevis();
      const moreData =
        res?.data.map((item) => ({
          ...item,
          typeTitle: item?.type?.title || "",
        })) || [];

      setFilteredData((prevItems) => [...prevItems, ...moreData]);
    } catch (error) {
      showErrorToaster("Erreur lors de la récupération des devis supplémentaires");
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  useEffect(() => {
    loadData();
  }, []);
const fetchUserDevis = async () => {
    setLoading(true);

    try {
      console.log("🚀 ~ fetchUserDevis ~ currentUser:", currentUser);
      if (currentUser.role === "gestionnaire" || currentUser.role === "admin") {
        const res = await DevisService.getAllClientsDevis(); // <-- fetch all devis
        console.log("🚀 ~ fetchUserDevisgg ~ res:", res);
        setDevisLists(res);
      } else {
        const res = await DevisService.getDevisByUserId(currentUser.userId); // <-- fetch user's devis
        console.log("🚀 ~ fetchUserDevishhh ~ res:", res);
        setDevisLists(res);
      }
    } catch (error) {
      console.error(error); // Log the error for debugging
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  useEffect(() => {
    let filtered = devisLists;

    if (searchQuery) {
      const lowerQuery = searchQuery.toLowerCase();
      filtered = filtered.filter((devis) => {
        const budget = devis.budgetEstime?.toString().toLowerCase() || "";
        const secteur = devis.activitySector?.toLowerCase() || "";
        const devise = devis.devise?.toLowerCase() || "";
        const titre = devis.title?.toLowerCase() || "";
        const description = devis.description?.toLowerCase() || "";
        const clientPrenom = devis.clientId?.firstname?.toLowerCase() || "";
        const clientNom = devis.clientId?.lastname?.toLowerCase() || "";
        const societe = devis?.company?.toLowerCase() || "";
        return (
          budget.includes(lowerQuery) ||
          secteur.includes(lowerQuery) ||
          devise.includes(lowerQuery) ||
          titre.includes(lowerQuery) ||
          description.includes(lowerQuery) ||
          clientPrenom.includes(lowerQuery) ||
          clientNom.includes(lowerQuery) ||
          societe.includes(lowerQuery)
        );
      });
    }

    if (statusFilter) {
      filtered = filtered.filter((devis) => devis.statut === statusFilter);
    }

    setFilteredData(filtered);
  }, [searchQuery, statusFilter, devisLists]);

  return (
    <ClientLayout>
      <div id="ClientsListPage" className="home-page">
        <div className="container-fluid">
          <div className="header-section">
            {devisList.length === 0 && (
              <div className="devis-headder d-flex justify-content-between align-items-center mb-4 p-3">
                <div className="devis-total me-4 fs-5">
                  {t("Devis")} ({devisList.length})
                </div>
                <div className="d-flex gap-3 align-items-center">
                  <div className="search-container py-3">
                    <div className="search-input-wrapper position-relative">
                      <img
                        src={iconSearch}
                        alt="search icon"
                        className="search-icon"
                      />
                      <input
                        type="text"
                        id="search-input"
                        className="form-control ps-5 pe-5"
                        placeholder="Rechercher ..."
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="d-flex align-items-center">
              <h3 className="title">
                {devisList.length > 0 ? t("Liste des devis") : t("Bienvenue !")}
              </h3>
              <div className="view-mode-switch d-flex gap-2">
                <button
                  className={`btn btn-sm ${viewMode === "grid" ? "AppButton1 primary" : "AppButton2 secondarys"}`}
                  onClick={() => setViewMode("grid")}
                  disabled={currentUser?.role === "visitor"}
                >
                  <GridIcon className="grid-icon" />
                </button>
                <button
                  className={`btn btn-sm ${viewMode === "list" ? "AppButton1 primary" : "AppButton2 secondarys"}`}
                  onClick={() => setViewMode("list")}
                  disabled={currentUser?.role === "visitor"}
                >
                  <ListIcon className="list-icon" />
                </button>
              </div>
              <div className="d-flex gap-3 align-items-center ms-auto">
                <select
                  className="form-select ms-2"
                  style={{ maxWidth: "180px" }}
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">{t("Tous les statuts")}</option>
                  <option value="Nouveau">{t("Nouveau")}</option>
                  <option value="En cours">{t("En cours")}</option>
                  <option value="Traité">{t("Traité")}</option>
                </select>
                <div className="search-container py-3">
                  <div className="search-input-wrapper position-relative">
                    <img
                      src={iconSearch}
                      alt="search icon"
                      className="search-icon"
                    />
                    <input
                      type="text"
                      id="search-input"
                      className="form-control ps-5 pe-5" // ps-5 adds left padding so the icon doesn't overlap text
                      placeholder="Rechercher ..."
                      value={searchQuery} // Bind search query to input value
                      onChange={handleSearch}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={devisList.length === 0 ? "devis-container" : ""}>
              {devisList.length === 0 ? (
                <div className="empty-data-container text-center p-3">
                  <img
                    src={emptyDevis}
                    alt="empty devis Logo"
                    className="logo w-100"
                  />
                </div>
              ) : (
                <div className="d-flex justify-content-between align-items-center">
                  <div className="devis-list-container">
                    {isMobile > 599 ? (
                      <div className="devis-list-container">
                        {viewMode === "grid" ? (
                          <DevisUser
                            devisList={filteredData}
                            fetchUserDevis={fetchUserDevis}
                            viewMode="grid"
                            isVisitor={currentUser?.role === "visitor"} // Pass this prop to disable actions
                          />
                        ) : (
                          <DevisUser
                            devisList={filteredData}
                            fetchUserDevis={fetchUserDevis}
                            viewMode="list"
                            isVisitor={currentUser?.role === "visitor"} // Pass this prop to disable actions
                          />
                        )}
                      </div>
                    ) : (
                      <InfiniteScroll
                        dataLength={filteredData.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={
                          <div className="d-flex justify-content-center">
                            <Loading />
                          </div>
                        }
                      >
                        <DevisUser
                          devisList={devisLists}
                          fetchUserDevis={fetchUserDevis}
                          isVisitor={currentUser?.role === "visitor"} // Disable actions for visitors
                        />
                      </InfiniteScroll>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ClientLayout>
    
  );
}

export default ClientsDevisList;

